module.exports = __webpack_public_path__ + "7456ed023ab236503b5803a1897d975e.png";